<template>
  <div class="snackbar snackbar--primary snackbar--scroll">
    <!-- eslint-disable vue/no-v-html -->
    <p v-html="message" />
    <!--eslint-enable-->
  </div>
</template>

<script>
export default {
  name:'Snackbar',
  props:{
    // allMessages:{
    //   type: Array,
    //   required: true,
    // },
    messageToDisplay:{
      type:Object,
      required: true
    }
  },
  computed: {
      message() {
        let message  =''
        let messageContent = this.messageToDisplay.content.replaceAll('<br/>',' ')
        message = '<p style="color:#ffffff;" class="pl-6">'+  this.messageToDisplay.header +' '+messageContent +'</p>'          
        // if((this.allMessages !== null || this.allMessages !== undefined) && this.allMessages.length > 0){
        //   this.allMessages.forEach(function(thisMessage) {
        //     if(thisMessage.type === 3)
        //     {
        //       let messageContent = thisMessage.content.replaceAll('<br/>',' ')
        //       let newMessage = '<p style="color:#ffffff;" class="pl-6">'+  thisMessage.header +': '+messageContent +'</p>'          

        //       message = message + newMessage
        //       // if(idx=== messages.length-1){
        //       //   message = message + newMessage
        //       // }else{
        //       //   message = message + newMessage + ' - '
        //       // }
        //     }
        //   })
        // }

        return  message
      }
  }
}
</script>

<style lang="scss" scoped>

</style>